import { withI18n } from 'react-i18next';
import DateRange from './DateRange';

export const pureComponent = DateRange;
export default withI18n()(DateRange);
